class ReviewsCarousel extends HTMLElement {
  connectedCallback() {
    this._slides = Array.from(this.querySelectorAll('.reviews-carousel__slide'));
    this._dotsContainer = this.querySelector('[data-dots]');
    this._speed = parseInt(this.dataset.speed) || 3000;
    this._current = 0;
    this._timer = null;

    if (this._slides.length === 0) return;

    this._buildDots();
    this._show(0);

    this.querySelector('[data-prev]')?.addEventListener('click', () => {
      this._prev();
      this._restart();
    });

    this.querySelector('[data-next]')?.addEventListener('click', () => {
      this._next();
      this._restart();
    });

    if (this._slides.length > 1) {
      this._start();
      this.addEventListener('mouseenter', () => this._pause());
      this.addEventListener('mouseleave', () => this._start());
    }
  }

  disconnectedCallback() {
    this._pause();
  }

  _buildDots() {
    if (!this._dotsContainer || this._slides.length <= 1) return;

    this._slides.forEach((_, i) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'reviews-carousel__dot';
      btn.setAttribute('aria-label', `Review ${i + 1}`);
      btn.addEventListener('click', () => {
        this._show(i);
        this._restart();
      });
      this._dotsContainer.appendChild(btn);
    });

    this._dots = Array.from(this._dotsContainer.querySelectorAll('.reviews-carousel__dot'));
  }

  _show(index) {
    this._slides.forEach((slide, i) => {
      slide.classList.toggle('active', i === index);
    });

    if (this._dots) {
      this._dots.forEach((dot, i) => dot.classList.toggle('active', i === index));
    }

    this._current = index;
  }

  _prev() {
    this._show((this._current - 1 + this._slides.length) % this._slides.length);
  }

  _next() {
    this._show((this._current + 1) % this._slides.length);
  }

  _start() {
    this._pause();
    if (this._slides.length > 1) {
      this._timer = setInterval(() => this._next(), this._speed);
    }
  }

  _pause() {
    if (this._timer) {
      clearInterval(this._timer);
      this._timer = null;
    }
  }

  _restart() {
    this._pause();
    this._start();
  }
}

customElements.define('reviews-carousel', ReviewsCarousel);
